import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { AboutTourObject } from 'shared/api/tours/tour-detail'
import { ABOUT_TOUR_TOPICS_ICONS } from 'shared/constants/tours.ts'

import { TabsInfoAlert } from './components/tabs-info-alert'
import { TabsInfoItem } from './components/tabs-info-item'
import s from './styles.module.scss'

interface Props {
  data: AboutTourObject[]
}

export const AboutTour: FC<Props> = ({ data }) => {
  const { t } = useTranslation()
  const renderContent = (item: AboutTourObject) => {
    const icon = ABOUT_TOUR_TOPICS_ICONS[item.topic]

    switch (item.topic) {
      case 'COMMENT':
        return (
          <TabsInfoItem
            key={item.topic}
            title={item.name}
            subtitle={item.description}
            icon={icon}
            isGradientText
          />
        )
      case 'ATTENTION':
        return (
          <TabsInfoAlert
            key={item.topic}
            bgColor="rgba(234, 88, 12, 0.10)"
            color="#7C2D12"
          >
            <p className={clsx('bold-14', s.alertTitle)}>{item.name}</p>
            <p className={clsx('medium-14', s.alertDescription)}>
              {item.description}
            </p>
          </TabsInfoAlert>
        )
      default:
        return (
          <TabsInfoItem
            key={item.topic}
            title={item.name}
            subtitle={item.description}
            icon={icon}
          />
        )
    }
  }

  return (
    <div className={s.aboutTour}>
      <p className={clsx('bold-22', s.title)}>{t('tours_block.about_tour')}</p>
      <p className={clsx(s.subtitle, 'bold-18')}>
        {t('tours_block.package_price_includes')}
      </p>
      <div className={s.infoList}>
        {data.map((item) => renderContent(item))}
      </div>
    </div>
  )
}
